import type { FilterOptions } from '../data/types'
import type { FilterState } from '../data/filterState'
import { DEFAULT_FILTERS } from '../data/filterState'
import { FilterPanel, SeriesSelect, WhenChips } from './FilterPanel'
import styles from './MobileFilterSheet.module.css'

/** Mobile bottom sheet, MobileFilters.dc.html: When chips, Registration/Racing type checkboxes,
 *  Series select, sticky "Show N events" footer. Location/radius editing lives only in the
 *  hero's LocationPicker (shared with desktop) - not duplicated here as a second location
 *  control. */
export function MobileFilterSheet({
  filters,
  selected,
  pendingCount,
  onChange,
  onClose,
}: {
  filters: FilterOptions
  selected: FilterState
  pendingCount: number
  onChange: (next: FilterState) => void
  onClose: () => void
}) {
  return (
    <div className={styles.backdrop} onClick={onClose}>
      <section role="dialog" aria-label="Filter events" className={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <div className={styles.grabber}>
          <span className={styles.grabberBar} />
        </div>
        <div className={styles.header}>
          <h1 className={styles.title}>Filters</h1>
          <div className={styles.headerActions}>
            <button type="button" className={styles.resetButton} onClick={() => onChange({ ...DEFAULT_FILTERS, search: selected.search, sort: selected.sort })}>
              Reset
            </button>
            <button type="button" aria-label="Close filters" className={styles.closeButton} onClick={onClose}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>
        </div>

        <div className={styles.body}>
          <WhenChips selected={selected} onChange={onChange} />
          <FilterPanel filters={filters} selected={selected} onChange={onChange} />
          <SeriesSelect filters={filters} selected={selected} onChange={onChange} />
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.showButton} onClick={onClose}>
            Show {pendingCount} events
          </button>
        </div>
      </section>
    </div>
  )
}
